import { Col, Container, Row } from 'react-bootstrap';
import './Benefits.css';
import overview from 'assets/images/features/Humaaans.png'
const Hero = () => {
    return (
        <>
            <div className='overview-section'>
                <section className="hero-4   pb-5 pt-2 py-sm-3">
                    <Container>
                        <Row className="align-items-center">
                            <Col lg={6} md={6} className="mb-4 mb-md-0 text-center text-md-start">
                                <h1 className="hero-title mt-0">
                                    Overview of <span className="highlight highlight-warning d-inline-block">SalesTrackify</span> CRM.
                                </h1>
                                <p className="fs-16 text-muted pt-3 w-100 w-md-75 mx-auto mx-md-0">
                                    SalesTrackify CRM is designed to empower sales teams with tools to streamline their workflow, improve productivity, and close deals faster. With an intuitive interface and robust features, SalesTrackify helps businesses track leads, manage sales pipelines, and analyze performance with precision.
                                </p>
                            </Col>
                            <Col lg={6} md={6} sm={12} className="text-center text-md-end ps-lg-5">
                                <div className="img-container text-end ps-lg-5" data-aos="zoom-in">
                                    <Row className="align-items-center mt-md-0 mt-4">
                                        <img src={overview} loading="lazy" className="bg-white" alt="" />

                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </section>
            </div>
        </>
    );
};

export default Hero;
